import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { createPipelineRequest } from "@azure/core-rest-pipeline";
import { createClientPipeline } from "./pipeline.js";
import { flattenResponse } from "./utils.js";
import { getCachedDefaultHttpClient } from "./httpClientCache.js";
import { getOperationRequestInfo } from "./operationHelpers.js";
import { getRequestUrl } from "./urlHelpers.js";
import { getStreamingResponseStatusCodes } from "./interfaceHelpers.js";
import { logger } from "./log.js";
/**
 * Initializes a new instance of the ServiceClient.
 */

export var ServiceClient = /*#__PURE__*/function () {
  /**
   * The ServiceClient constructor
   * @param credential - The credentials used for authentication with the service.
   * @param options - The service client options that govern the behavior of the client.
   */
  function ServiceClient() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ServiceClient);

    var _a, _b;

    this._requestContentType = options.requestContentType;
    this._endpoint = (_a = options.endpoint) !== null && _a !== void 0 ? _a : options.baseUri;

    if (options.baseUri) {
      logger.warning("The baseUri option for SDK Clients has been deprecated, please use endpoint instead.");
    }

    this._allowInsecureConnection = options.allowInsecureConnection;
    this._httpClient = options.httpClient || getCachedDefaultHttpClient();
    this.pipeline = options.pipeline || createDefaultPipeline(options);

    if ((_b = options.additionalPolicies) === null || _b === void 0 ? void 0 : _b.length) {
      var _iterator = _createForOfIteratorHelper(options.additionalPolicies),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _step.value,
              policy = _step$value.policy,
              position = _step$value.position;
          // Sign happens after Retry and is commonly needed to occur
          // before policies that intercept post-retry.
          var afterPhase = position === "perRetry" ? "Sign" : undefined;
          this.pipeline.addPolicy(policy, {
            afterPhase: afterPhase
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
  /**
   * Send the provided httpRequest.
   */


  _createClass(ServiceClient, [{
    key: "sendRequest",
    value: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.pipeline.sendRequest(this._httpClient, request));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendRequest(_x) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
    /**
     * Send an HTTP request that is populated using the provided OperationSpec.
     * @typeParam T - The typed result of the request, based on the OperationSpec.
     * @param operationArguments - The arguments that the HTTP request's templated values will be populated from.
     * @param operationSpec - The OperationSpec to use to populate the httpRequest.
     */

  }, {
    key: "sendOperationRequest",
    value: function () {
      var _sendOperationRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(operationArguments, operationSpec) {
        var endpoint, url, request, operationInfo, contentType, options, requestOptions, rawResponse, flatResponse, _rawResponse, _flatResponse;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                endpoint = operationSpec.baseUrl || this._endpoint;

                if (endpoint) {
                  _context2.next = 3;
                  break;
                }

                throw new Error("If operationSpec.baseUrl is not specified, then the ServiceClient must have a endpoint string property that contains the base URL to use.");

              case 3:
                // Templatized URLs sometimes reference properties on the ServiceClient child class,
                // so we have to pass `this` below in order to search these properties if they're
                // not part of OperationArguments
                url = getRequestUrl(endpoint, operationSpec, operationArguments, this);
                request = createPipelineRequest({
                  url: url
                });
                request.method = operationSpec.httpMethod;
                operationInfo = getOperationRequestInfo(request);
                operationInfo.operationSpec = operationSpec;
                operationInfo.operationArguments = operationArguments;
                contentType = operationSpec.contentType || this._requestContentType;

                if (contentType && operationSpec.requestBody) {
                  request.headers.set("Content-Type", contentType);
                }

                options = operationArguments.options;

                if (options) {
                  requestOptions = options.requestOptions;

                  if (requestOptions) {
                    if (requestOptions.timeout) {
                      request.timeout = requestOptions.timeout;
                    }

                    if (requestOptions.onUploadProgress) {
                      request.onUploadProgress = requestOptions.onUploadProgress;
                    }

                    if (requestOptions.onDownloadProgress) {
                      request.onDownloadProgress = requestOptions.onDownloadProgress;
                    }

                    if (requestOptions.shouldDeserialize !== undefined) {
                      operationInfo.shouldDeserialize = requestOptions.shouldDeserialize;
                    }

                    if (requestOptions.allowInsecureConnection) {
                      request.allowInsecureConnection = true;
                    }
                  }

                  if (options.abortSignal) {
                    request.abortSignal = options.abortSignal;
                  }

                  if (options.tracingOptions) {
                    request.tracingOptions = options.tracingOptions;
                  }
                }

                if (this._allowInsecureConnection) {
                  request.allowInsecureConnection = true;
                }

                if (request.streamResponseStatusCodes === undefined) {
                  request.streamResponseStatusCodes = getStreamingResponseStatusCodes(operationSpec);
                }

                _context2.prev = 15;
                _context2.next = 18;
                return this.sendRequest(request);

              case 18:
                rawResponse = _context2.sent;
                flatResponse = flattenResponse(rawResponse, operationSpec.responses[rawResponse.status]);

                if (options === null || options === void 0 ? void 0 : options.onResponse) {
                  options.onResponse(rawResponse, flatResponse);
                }

                return _context2.abrupt("return", flatResponse);

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2["catch"](15);

                if (typeof _context2.t0 === "object" && (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.response)) {
                  _rawResponse = _context2.t0.response;
                  _flatResponse = flattenResponse(_rawResponse, operationSpec.responses[_context2.t0.statusCode] || operationSpec.responses["default"]);
                  _context2.t0.details = _flatResponse;

                  if (options === null || options === void 0 ? void 0 : options.onResponse) {
                    options.onResponse(_rawResponse, _flatResponse, _context2.t0);
                  }
                }

                throw _context2.t0;

              case 28:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[15, 24]]);
      }));

      function sendOperationRequest(_x2, _x3) {
        return _sendOperationRequest.apply(this, arguments);
      }

      return sendOperationRequest;
    }()
  }]);

  return ServiceClient;
}();

function createDefaultPipeline(options) {
  var credentialScopes = getCredentialScopes(options);
  var credentialOptions = options.credential && credentialScopes ? {
    credentialScopes: credentialScopes,
    credential: options.credential
  } : undefined;
  return createClientPipeline(Object.assign(Object.assign({}, options), {
    credentialOptions: credentialOptions
  }));
}

function getCredentialScopes(options) {
  if (options.credentialScopes) {
    return options.credentialScopes;
  }

  if (options.endpoint) {
    return "".concat(options.endpoint, "/.default");
  }

  if (options.baseUri) {
    return "".concat(options.baseUri, "/.default");
  }

  if (options.credential && !options.credentialScopes) {
    throw new Error("When using credentials, the ServiceClientOptions must contain either a endpoint or a credentialScopes. Unable to create a bearerTokenAuthenticationPolicy");
  }

  return undefined;
}